import { GraduationCap, Clock, ShieldCheck, Buildings } from '@phosphor-icons/react';

export const WhyChooseUs = () => {
  const features = [
    {
      icon: GraduationCap,
      title: "MBA-Led Professionalism",
      description: "Years of large-scale corporate development experience (Pulte Homes) means your documents are handled with the same precision as a multimillion-dollar contract.",
    },
    {
      icon: Buildings,
      title: "Tennessee SOS Specialist",
      description: "Direct working knowledge of Secretary of State filing requirements — apostille, authentications, and corporate filings handled with insider efficiency.",
    },
    {
      icon: Clock,
      title: "Truly 24 / 7",
      description: "Hospital bedsides at midnight. Last-minute international flights at 6 AM. I answer the phone when other notaries don't.",
    },
    {
      icon: ShieldCheck,
      title: "Bonded & Commissioned",
      description: "Fully insured Tennessee Notary Public + Certified Signing Agent. Background-checked, bonded, and trusted by local law firms and title companies.",
    },
  ];

  return (
    <section data-testid="why-choose-us-section" className="py-24 bg-[#800000] relative overflow-hidden">
      {/* Decorative pattern */}
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: 'radial-gradient(circle, #D4AF37 1px, transparent 1px)',
        backgroundSize: '32px 32px'
      }} />

      {/* Top accent line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-3 mb-5">
            <div className="h-px w-8 bg-[#D4AF37]" />
            <span className="text-[#D4AF37] text-xs font-semibold tracking-[0.3em] uppercase">The India Difference</span>
            <div className="h-px w-8 bg-[#D4AF37]" />
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-semibold text-white mb-4">
            Elite Service. <span className="italic gold-shimmer">Neighborly Heart.</span>
          </h2>
          <p className="text-white/75 text-base sm:text-lg leading-relaxed">
            What you get with India isn't just a stamp — it's an MBA, a small-business owner, and a Nashville native who treats every client like family.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              data-testid={`why-choose-card-${index}`}
              className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-sm p-7 hover:bg-white/[0.08] hover:border-[#D4AF37]/40 transition-all duration-500 group"
            >
              <div className="w-14 h-14 rounded-full bg-[#D4AF37]/15 flex items-center justify-center mb-6 group-hover:bg-[#D4AF37]/25 transition-colors">
                <feature.icon weight="duotone" size={28} className="text-[#D4AF37]" />
              </div>
              <h3 className="font-serif-display text-xl font-semibold text-white mb-3 leading-tight">
                {feature.title}
              </h3>
              <p className="text-white/70 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
